module.exports = __webpack_public_path__ + "img/generator3.c8c1419d.png";